import * as Sentry from "@sentry/react";
import { useEffect } from "react";

import { CopyIcon } from "~/components/ui/icons/copy";
import { toast } from "~/components/ui/toast";
import { useCopyToClipboard } from "~/hooks/use-copy-to-clipboard";
import { track } from "~/libs/analytics";

type CopyProps = {
  value: string;
  successMessage: string;
  trackLabel: string;
} & React.ComponentProps<"button">;

export const Copy: React.FC<CopyProps> = ({
  successMessage,
  trackLabel,
  value,
  ...props
}: CopyProps) => {
  const [clipboardState, clipboardStateToClipboard] = useCopyToClipboard();

  useEffect(() => {
    const { value, error } = clipboardState;
    if (value) {
      toast.success(successMessage);
    }
    track("CopyToClipboard", {
      label: trackLabel,
    });
    if (error) {
      Sentry.captureException(error);
    }
  }, [clipboardState]);

  return (
    <button
      type="button"
      onClick={() => clipboardStateToClipboard(value)}
      {...props}
    >
      <CopyIcon className="size-4" />
    </button>
  );
};

Copy.displayName = "Copy";
